import styled, { css } from "styled-components"

export const Avatar = styled.img`
  height: 75px;
  width: 75px;
  border-radius: 50%;
  float: right;
`

export const Div = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  margin: 0;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
  display: flex;
  justify-content: center;
`

export const Para = styled.p`
  font-size: 6rem;
  font-family: Helvetica Neue;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: white;
`

export const Skills = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
`

export const Skill = styled.div`
  padding: 0.2rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 2rem;
  font-size: 0.8rem;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
`

export const Media = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: 1rem;
  width: 100%;
  padding-bottom: 100%;
`

export const Img = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: 1rem;
  object-fit: cover;
  object-position: 50% 50%;
  margin: 0;
  z-index: 1;

  ${({ obfuscated }) =>
    !!obfuscated &&
    css`
      filter: blur(30px);
      pointer-events: none;
    `}
`

export const Text = styled.div``

export const PlayButton = styled.svg`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 2;
`

export const CloudButton = styled.svg`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
`
